import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';

import AskQuestion from './Pages/AskQuestion';
import AskQuestionConfirmation from './Pages/AskQuestionConfirmation';
import HelpHome from './Pages/HelpHome';
import * as routes from './routes';

const HelpRoutes: FC = () => {
  return (
    <Switch>
      <Route
        component={AskQuestionConfirmation}
        path={routes.askQuestionConfirmation}
      />
      <Route component={AskQuestion} path={routes.askQuestion} />
      <Route component={HelpHome} exact path={routes.root} />
    </Switch>
  );
};

export default HelpRoutes;
